// UI checks supplement (and never replace) the server's model ACL and release gates.
export function resolveOnboardingModelId(models, selectedId, requestedId) {
  const ids = models.map((model) => String(model.id))
  if (requestedId) return ids.includes(String(requestedId)) ? String(requestedId) : ''
  return ids.includes(String(selectedId)) ? String(selectedId) : (ids[0] || '')
}

export function canPublishOnboardingRelease(session, release) {
  if (!session || !release || ['published', 'rolled_back', 'cancelled', 'analyzing'].includes(session.status)) return false
  const readiness = session.readiness || {}
  const tests = release.test_summary || {}
  return release.status === 'tested'
    && readiness.ready === true
    && Number(readiness.session_state_version) === Number(session.state_version)
    && Boolean(release.snapshot_hash)
    && tests.snapshot_hash === release.snapshot_hash
    && tests.status === 'passed'
    && tests.behavior_execution?.status === 'passed'
}
